import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import styles from './LogoShare.styles';

export type LogoShareIconProps = WithStyles<typeof styles> & {
  color?: string;
};

const LogoShareIconComponent: FC<LogoShareIconProps> = ({ classes, color = '#7E8899' }) => {
  return (
    <svg width="60" height="52" viewBox="0 0 60 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...classes}>
      <rect x="0.867188" width="48" height="48" rx="12" fill="#9764D6" />
      <path
        d="M24.998 35.4502C26.4542 35.4502 27.6346 36.6308 27.6348 38.0869C27.6348 39.5432 26.4544 40.7246 24.998 40.7246C23.5418 40.7245 22.3613 39.5432 22.3613 38.0869C22.3615 36.6308 23.5419 35.4503 24.998 35.4502ZM28.2373 28.7334L36.5645 36.1338C35.1777 37.442 33.5684 38.5181 31.8008 39.2969L24.9932 32.1426L18.1914 39.293C16.4237 38.5142 14.8145 37.4381 13.4277 36.1299L21.75 28.7354L24.9951 25.8525L28.2373 28.7334ZM20.124 20.6172L23.0068 23.8623L20.126 27.1035L12.7256 35.4316C11.4174 34.0449 10.3413 32.4356 9.5625 30.668L16.7168 23.8604L9.56543 17.0576C10.3442 15.2899 11.4203 13.6808 12.7285 12.2939L20.124 20.6172ZM37.2627 12.2939C38.5709 13.6808 39.647 15.2899 40.4258 17.0576L33.2744 23.8604L40.4287 30.668C39.6499 32.4356 38.5738 34.0449 37.2656 35.4316L29.8652 27.1035L26.9844 23.8623L29.8672 20.6172L37.2627 12.2939ZM10.7695 21.2285C12.2258 21.2285 13.4062 22.409 13.4062 23.8652C13.4062 25.3216 12.2259 26.502 10.7695 26.502C9.31328 26.5019 8.13281 25.3215 8.13281 23.8652C8.13288 22.409 9.31333 21.2286 10.7695 21.2285ZM39.2188 21.2285C40.675 21.2285 41.8554 22.409 41.8555 23.8652C41.8555 25.3216 40.6751 26.502 39.2188 26.502C37.7625 26.5018 36.582 25.3215 36.582 23.8652C36.5821 22.409 37.7626 21.2286 39.2188 21.2285ZM31.8008 8.42969C33.5684 9.20849 35.1776 10.2845 36.5645 11.5928L28.2373 18.9922L24.9951 21.874L21.75 18.9912L13.4277 11.5957C14.8145 10.2875 16.4237 9.21141 18.1914 8.43262L24.9932 15.584L31.8008 8.42969ZM24.998 7C26.4543 7 27.6357 8.18046 27.6357 9.63672C27.6357 11.093 26.4544 12.2734 24.998 12.2734C23.5419 12.2733 22.3613 11.0929 22.3613 9.63672C22.3614 8.18056 23.5419 7.00016 24.998 7Z"
        fill="white"
      />
      <circle cx="45.1328" cy="38" r="12.5" fill="#EAECF0" stroke="white" strokeWidth="3" />
      <g clipPath="url(#clip0_3894_8148)">
        <path
          d="M42.4658 40.6667L45.1325 38M45.1325 38L47.7992 40.6667M45.1325 38V44M50.4658 41.1619C51.2802 40.4894 51.7992 39.472 51.7992 38.3333C51.7992 36.3083 50.1575 34.6667 48.1325 34.6667C47.9868 34.6667 47.8505 34.5907 47.7766 34.4652C46.9072 32.9899 45.3021 32 43.4658 32C40.7044 32 38.4658 34.2386 38.4658 37C38.4658 38.3774 39.0228 39.6247 39.9238 40.529"
          stroke={color}
          strokeWidth="1.65"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3894_8148">
          <rect width="16" height="16" fill="white" transform="translate(37.1328 30)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoShareIcon = withStyles(styles)(LogoShareIconComponent);
